import axios from 'axios';
import { applyAuthRequestInterceptor, applyEnvelopeInterceptor } from './axiosInterceptors';

/** API origin (scheme+host, no path). Empty for same-origin local dev. */
const API_ORIGIN = import.meta.env.VITE_API_BASE_URL ?? '';

const apiClient = axios.create({
  baseURL: `${API_ORIGIN}/api`,
  timeout: 15000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

applyAuthRequestInterceptor(apiClient);
applyEnvelopeInterceptor(apiClient);

export default apiClient;
